import {
  registerDecorator,
  ValidationArguments,
  ValidationOptions,
} from "class-validator";

export function IsValidDnsContent(validationOptions?: ValidationOptions) {
  return function (object: Object, propertyName: string) {
    registerDecorator({
      name: "isValidContent",
      target: object.constructor,
      propertyName,
      options: validationOptions,
      validator: {
        validate(value: any, args: ValidationArguments) {
          const record: any = args.object;

          if (record.type === "A") {
            // IPv4 check
            return /^(\d{1,3}\.){3}\d{1,3}$/.test(value);
          }

          if (record.type === "AAAA") {
            // IPv6 check (basic regex, or use a library)
            return /^([0-9a-fA-F]{0,4}:){2,7}[0-9a-fA-F]{0,4}$/.test(value);
          }

          if (["CNAME", "TXT", "NS", "MX", "SRV"].includes(record.type)) {
            return typeof value === "string" && value.trim().length > 0;
          }

          return false; // unknown type
        },
        defaultMessage(args: ValidationArguments) {
          const record: any = args.object;
          return `Content is not valid for DNS type "${record.type}"`;
        },
      },
    });
  };
}
